import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AddProductVariantPageRBAC = {
  pageID: 'c756d90439bed7e3f2eb55af8e73a303',
  elementID: {
    ButtonAddSubmit: '01af7e264a5772359cfea3ca34bf4721',
  },
} as const

export const EditProductVariantPageRBAC = {
  pageID: '14c3d17fdc8b9d1e3db64546a61b21c2',
  elementID: {
    ButtonEditSubmit: '0903b182219e045e9f7f306b06cf77fc',
  },
} as const

export const useRBACAddProductVariantPage = createUseRBAC(AddProductVariantPageRBAC.elementID)
export const useRBACEditProductVariantPage = createUseRBAC(EditProductVariantPageRBAC.elementID)

export type UseRBACAddProductVariantPageType = ReturnType<typeof useRBACAddProductVariantPage>
export type UseRBACEditProductVariantPageType = ReturnType<typeof useRBACEditProductVariantPage>
